import { API_BASE_URL, endpoints } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";
import { Attribute } from "../types/attribute";
import { CreateAttributeDto } from "../types/attribute";

export const attributesApi = {
  getAll: async (): Promise<Attribute[]> => {
    const response = await fetch(`${API_BASE_URL}/attributes`, {
      headers: authHeadersForGet(),
    });
    return response.json();
  },

  getOne: async (reference: string): Promise<Attribute> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes/${reference}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  create: async (attribute: CreateAttributeDto): Promise<Attribute> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(attribute),
      }
    );
    return response.json();
  },

  update: async (
    reference: string,
    attribute: Partial<CreateAttributeDto>
  ): Promise<Attribute> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes/${reference}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(attribute),
      }
    );
    return response.json();
  },

  delete: async (reference: string): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes/${reference}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },

  addOption: async (reference: string, option: any): Promise<any> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes/${reference}/options`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(option),
      }
    );
    return response.json();
  },

  updateOption: async (reference: string, optionId: number, option: any): Promise<any> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes/${reference}/options/${optionId}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(option),
      }
    );
    return response.json();
  },

  removeOption: async (reference: string, optionId: number): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}/attributes/${reference}/options/${optionId}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },
};
